import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateFreeThing = ({ onFreeThingCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    title: "",
    subtitle: "",
    description: "",
    download_link: "",
    icon: "",
    button_text: "",
    button_icon: ""
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/freethings`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onFreeThingCreated) {
        onFreeThingCreated();
      }
      
      // Reset form after successful submission
      setFormData({
        slug: "",
        title: "",
        subtitle: "",
        description: "",
        download_link: "",
        icon: "",
        button_text: "",
        button_icon: ""
      });
      
      alert("Free Thing created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the Free Thing.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Free Thing</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., free-ebook"
          />
        </div>

        <div>
          <label className="block mb-1">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., Free Ebook"
          />
        </div>

        <div>
          <label className="block mb-1">Subtitle:</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., Get your free copy today"
          />
        </div>

        <div>
          <label className="block mb-1">Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            rows="4"
            required
            placeholder="Enter detailed description..."
          ></textarea>
        </div>

        <div>
          <label className="block mb-1">Download Link:</label>
          <input
            type="url"
            name="download_link"
            value={formData.download_link}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., https://example.com/download"
          />
        </div>

        <div>
          <label className="block mb-1">Icon (class or URL):</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., fas fa-book or image URL"
          />
        </div>

        <div>
          <label className="block mb-1">Button Text:</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., Download Now"
          />
        </div>

        <div>
          <label className="block mb-1">Button Icon (class or URL):</label>
          <input
            type="text"
            name="button_icon"
            value={formData.button_icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., fas fa-download"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create Free Thing"}
        </button>
      </form>
    </div>
  );
};

export default CreateFreeThing;